import styled from "styled-components"
import { colors, radius, spacing, typography } from "Shared/tokens"

export const GanttContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .ganttChart {
    flex: 1 1 auto;
    min-height: 0;
  }
`

export const GanttHint = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing[2]}px;
  height: 100%;
  padding: ${spacing[4]}px;
  text-align: center;
  color: var(--text-secondary, ${colors.textSecondary});
  font-size: ${typography.bodySmall.size}px;
`

export const GanttSkipped = styled.div`
  flex: 0 0 auto;
  padding: ${spacing[1]}px ${spacing[2]}px;
  color: var(--status-warning-text, ${colors.status.warning.text});
  background: var(--status-warning-bg, ${colors.status.warning.bg});
  font-size: ${typography.caption.size}px;
  border-radius: ${radius.sm}px;
`
